import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const DeleteConfirmModal = ({
  open,
  title = "Delete Employee",
  message = "Are you sure you want to delete this employee? This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40">
      <div className="relative w-full max-w-md rounded-xl text-start bg-white shadow-xl p-6">
        
        {/* Close (X) */}
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <CloseIcon fontSize="small" />
        </button>

        {/* Title */}
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          {title}
        </h2>

        {/* Message */}
        <p className="text-sm text-gray-600 mb-6">
          {message}
        </p>

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm rounded-md border bg-white text-gray-700 hover:bg-gray-50"
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm rounded-md bg-[#DC2626] text-white hover:bg-[#B91C1C]"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
